<div class="form-grid">
  <label>
    <span>Heading</span>
    <input [ngModel]="block.heading" placeholder="Section heading" (ngModelChange)="updateHeading($event)" />
  </label>
  <label>
    <span>Level</span>
    <input
      type="number"
      min="1"
      max="6"
      [ngModel]="block.headingLevel"
      placeholder="2"
      (ngModelChange)="updateHeadingLevel($event)" />
  </label>
</div>
